import PropTypes from 'prop-types'
import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'next-i18next'
import { useContext } from 'react'
import { UserContext } from '@/root/context/UserContext'

const FormItemError = (props) => {
  const { children, modifiers } = props

  const userContext = useContext(UserContext)

  const modifierClasses = modifiers ? ' ' + modifiers.join(' ') : ''

  const { t } = useTranslation(
    userContext?.userSession?.sportType?.slug ??
      process.env.NEXT_PUBLIC_RINUS_DEFAULT_NAMESPACE ??
      process.env.NEXT_PUBLIC_RINUS_DEFAULT_SPORT
  )

  const { formState } = useFormContext()

  return (
    children &&
    formState.isSubmitted && (
      <div className={`FormError${modifierClasses}`}>
        <p className="FormError-copy">{t(children)}</p>
      </div>
    )
  )
}

FormItemError.propTypes = {
  modifiers: PropTypes.array,
  children: PropTypes.any
}

export default FormItemError
